export default "__VITE_ASSET__BDgvfzdZ__"